import { render, staticRenderFns } from "./AdminPricingPlanAdd.vue?vue&type=template&id=2b6680c8"
import script from "./AdminPricingPlanAdd.vue?vue&type=script&lang=js"
export * from "./AdminPricingPlanAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b6680c8')) {
      api.createRecord('2b6680c8', component.options)
    } else {
      api.reload('2b6680c8', component.options)
    }
    module.hot.accept("./AdminPricingPlanAdd.vue?vue&type=template&id=2b6680c8", function () {
      api.rerender('2b6680c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminPricingPlanAdd.vue"
export default component.exports